export default __webpack_public_path__ + "static/Quickinstallation_07-29a34198914d94480f87b61b26184f65.webp";